// lightbox.js
const lightbox = document.getElementById('lightbox');
const lightboxImage = document.getElementById('lightbox-image');
const lightboxClose = document.getElementById('lightbox-close');
const lightboxPrev = document.getElementById('lightbox-prev');
const lightboxNext = document.getElementById('lightbox-next');

if (lightbox) {
  const slides = document.querySelectorAll('.work-swiper .swiper-slide');
  let currentIndex = 0;

  // Collect all image sources - use largest from srcset for lightbox
  const images = [];
  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (img) {
      let fullSrc = img.src;
      if (img.srcset) {
        const sources = img.srcset.split(',').map((s) => {
          const parts = s.trim().split(/\s+/);
          return { url: parts[0], width: parseInt(parts[1]) || 0 };
        });
        sources.sort((a, b) => b.width - a.width);
        if (sources.length) {
          fullSrc = sources[0].url;
        }
      }
      images.push({ index, src: fullSrc, alt: img.alt || '' });
    }
  });

  function openLightbox(imageIndex) {
    currentIndex = imageIndex;
    showImage();
    lightbox.setAttribute('aria-hidden', 'false');
    lightbox.classList.add('is-active');
    document.documentElement.classList.add('no-scroll');
  }

  function closeLightbox() {
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.classList.remove('is-active');
    document.documentElement.classList.remove('no-scroll');
  }

  function showImage() {
    if (images[currentIndex]) {
      lightboxImage.src = images[currentIndex].src;
      lightboxImage.alt = images[currentIndex].alt;
    }
  }

  function prevImage() {
    currentIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
    showImage();
  }

  function nextImage() {
    currentIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
    showImage();
  }

  // Click on slide image to open lightbox
  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (img) {
      img.style.cursor = 'pointer';
      const imgIndex = images.findIndex((i) => i.index === index);
      img.addEventListener('click', () => openLightbox(imgIndex));
    }
  });

  lightboxClose.addEventListener('click', closeLightbox);
  lightboxPrev.addEventListener('click', prevImage);
  lightboxNext.addEventListener('click', nextImage);

  // Close on background click
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox || e.target.classList.contains('lightbox__image-wrapper')) {
      closeLightbox();
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('is-active')) return;

    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') prevImage();
    if (e.key === 'ArrowRight') nextImage();
  });
}
